import { useContext, useEffect, useState } from 'react';
import styles from './SideMenu.module.css';
import ConnUrls from '../Connections/ConnectURL';
import { useNavigate } from 'react-router-dom';
import { SideMenuContext } from '../Contexts/SideMenu_Context';
import SpecialUser from './SPUseSet';
import PopUpClearComp from '../PopUps/PopUpClearComp';
import { UserContext } from '../Contexts/User_Context';
import { MobiOrNotContext } from '../Contexts/MobiOrNot_Context';

const SideMenu = (props) => {

    const navigate = useNavigate();
    const [inoutEffect, setInoutEffect] = useState(styles.hideme)
    const [sideMenucon, setSideMenucon] = useContext(SideMenuContext)
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [user, setUser, UsspecialUsererEffectFunction] = useContext(UserContext);
    const [mnu, setMnu] = useState();
    const [loading, setLoading] = useState(true);
    const [thePopUp, setThePopUp] = useState();

    useEffect(() => {
        if (sideMenucon) {
            setLoading(false);
        } else {
        }
    }, [sideMenucon, user]);


    const showMenu = () => {
        setInoutEffect(styles.animate__backInRight)
    }

    const closeMnu = () => {
        setInoutEffect(styles.animate__backOutRight)
    }

    const goToItm = (thLnk) => {
        navigate(thLnk);
        closeMnu();
    }

    const specialForUs = () => {
        setThePopUp(
            <PopUpClearComp BtnTxt={"סגור"}
                title={"הזמנה ללקוח, פרטי הלקוח"}
                btnFStyle={"fatInBtn"}
                closePop={() => setThePopUp()}
                parentCLose={() => props.parentCLose()}
                theInsideComp={<SpecialUser closePop={() => setThePopUp()} />}
            />
        )


    }


    return (
        <>
            {!loading &&
                <>
                    <div className={`${!mobiOrNot ? styles.menuButton : styles.menuButtonMobile}`} >
                        <img src={`${ConnUrls.PermanentImages}/MnuItmNew.png`}
                            className={`pointing`} alt="Menu Button" onClick={() => showMenu()} />
                    </div>
                    <div className={`${styles.SideMenu} ${inoutEffect} animate__animated animate__faster`}>
                        <div className={styles.SideMnuWrap}>

                            <div className={`${styles.Xmark} pointing`}
                                style={{ backgroundImage: (`url("../PermanentImages/closeX.png")`) }}
                                onClick={() => closeMnu()}>

                            </div>
                            {/* 
                            <div key={"lgin"} onClick={() => goLogin()}
                                className={`${styles.mnuItem} pointing`}>התחברות</div> */}

                            <div className={styles.menuItems}>
                                {sideMenucon.map((item, index) => {
                                    return (
                                        <div key={index} onClick={() => goToItm(item.lnk)}
                                            className={`${styles.mnuItem} pointing`}>{item.txt}</div>
                                    )
                                })}

                            </div>

                            {user?.topUser &&
                                <div key={"specialUs"} onClick={() => specialForUs()}
                                    className={`${styles.mnuItem} ${styles.specialForUse} pointing`}>הזמנה ללקוח</div>
                            }

                        </div>
                    </div>
                    {thePopUp}
                </>
            }
        </>
    );
}

export default SideMenu;
